import React, {useState} from 'react'
import {TOURNAMENTSYSTEMS} from "../../../../../constants/tournamentSystems";
import DHDefaultDrawer from "../../../../general/DHDefaultDrawer";
import {PrimeIcons} from "primereact/api";
import TournamentCopySingleComp from "./TournamentCopySingleComp";
import TournamentCopyMultiComp from "./TournamentCopyMultiComp";


export default function TournamentCopySidebar({tournamentId, turniersystem, propMannschaftHeim,
                                                  propBezeichnung, propBezeichnungKurz,
                                                  onCopy, onClose}) {

    const [tabValue, setTabValue] = useState("SINGLE");

    const isLigaspieltag = () => {
        return turniersystem === TOURNAMENTSYSTEMS.LIGASPIELTAG.id;
    }

    const erzeugeTab = (value, key, icon, width, color) => {
        return <div style={{
            fontSize: 20, width: width,
            marginTop: 5,
            marginLeft: 5, cursor: "pointer",
            borderBottom: tabValue === key ? "2px solid red" : "none", textAlign: "center"
        }}
                    onClick={() => setTabValue(key)}>

            <i className={icon}
               style={{fontSize: 20, marginLeft: 5, marginRight: 5, color: color ? color : "white", cursor: "pointer"}}/><br/>
            {value.toUpperCase()}
        </div>
    }

    const getTabs = () => {
        let returnValue = [];
        returnValue.push(erzeugeTab("Einfach", "SINGLE", PrimeIcons.PLUS, 150));
        if( !isLigaspieltag()) {
            returnValue.push(erzeugeTab("Mehrfach", "MULTI", PrimeIcons.PLUS, 150));
        }
        return returnValue;
    }

    const getTabpanel = () => {
        if (tabValue === "SINGLE") {
            return <div>
                <TournamentCopySingleComp tournamentId={tournamentId} turniersystem={turniersystem} propBezeichnung={propBezeichnung}
                    propBezeichnungKurz={propBezeichnungKurz} propMannschaftHeim={propMannschaftHeim} onCopy={onCopy}/>
            </div>
        } else if (tabValue === "MULTI") {
            return <div>
                <TournamentCopyMultiComp tournamentId={tournamentId} propBezeichnung={propBezeichnung}
                                          propBezeichnungKurz={propBezeichnungKurz} onCopy={onCopy}/>
            </div>
        }
        return <></>
    }

    return <DHDefaultDrawer onClose={() => onClose()} show={true} title="Event kopieren" children={<>
        <div style={{display: "flex", flexWrap: "nowrap"}}>
            {getTabs()}
        </div>
        {getTabpanel()}
    </>
    }/>
}
